<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
        <router-link
      :to="
        '/StoreItemTransferReportPrint?id=' +
          select_branch.id +
          '&from=' +
          date_from +
          '&to=' +
          date_to +
          '&name=' +
          select_branch.name
      "
      target="_blank"
    >
      <v-icon>print</v-icon>
    </router-link>
    <v-container>
      <v-layout wrap="">
        <v-flex xs12 sm12 md12>
          <p style="font-size:18px">
            <b
              ><u>
                تقرير تحويل الاصناف بتاريخ من {{ date_from }} الي تاريخ
                {{ date_to }}</u
              >
            </b>
          </p>
        </v-flex>
        <v-flex xs12 sm6 md4>
          <v-autocomplete
            v-model="select_branch"
            :items="branches"
            item-text="name"
            item-value="id"
            label=" أختر الفرع "
            persistent-hint
            return-object
            single-line
          >
            <template v-slot:append-outer>
              <v-slide-x-reverse-transition mode="out-in">
              </v-slide-x-reverse-transition>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-dialog
            ref="dialog_from"
            v-model="modal_from"
            :return-value.sync="date_from"
            persistent
            lazy
            full-width
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="date_from"
                label="تاريخ من"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="date_from" scrollable>
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="modal_from = false"
                >Cancel</v-btn
              >
              <v-btn
                flat
                color="primary"
                @click="$refs.dialog_from.save(date_from)"
                >OK</v-btn
              >
            </v-date-picker>
          </v-dialog>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-dialog
            ref="dialog_to"
            v-model="modal_to"
            :return-value.sync="date_to"
            persistent
            lazy
            full-width
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="date_to"
                label="تاريخ الي"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="date_to" scrollable>
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="modal_to = false"
                >Cancel</v-btn
              >
              <v-btn flat color="primary" @click="$refs.dialog_to.save(date_to)"
                >OK</v-btn
              >
            </v-date-picker>
          </v-dialog>
        </v-flex>

        <v-flex xs12 sm6 md2>
          <v-btn @click="StoreItemTransferReport">تأكيد</v-btn>
        </v-flex>
        <br />
      </v-layout>

      <v-data-table
        :headers="headers"
        :items="fatworas"
        class="elevation-1"
        v-if="fatworas.length > 0"
        :rows-per-page-items="rowsPerPageItems"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-right">{{ props.item.item_name }}</td>
          <td class="text-xs-right">{{ props.item.item_num }}</td>
          <td class="text-xs-right">
            {{ props.item.fatwora ? props.item.fatwora.store_name_from : "" }}
          </td>
          <td class="text-xs-right">
            {{ props.item.fatwora ? props.item.fatwora.store_name_to : "" }}
          </td>
          <td class="text-xs-right">
            {{
              props.item.fatwora ? props.item.fatwora.emp_name_store_from : ""
            }}
          </td>
          <td class="text-xs-right">
            {{ props.item.fatwora ? props.item.fatwora.emp_name_store_to : "" }}
          </td>
          <td class="text-xs-right">{{ props.item.created_at }}</td>
        </template>
      </v-data-table>
      <div v-else>لا يوجد فواتير غير مسددة</div>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import {
  items,
  search_client_by_code,
  madionia_client,
  fatworas_client_no_sadad,
  employers,
  khazina,
  khazna_fatworas,
  branches,
  StoreItemTransferReport,
  log_me
} from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [11400, 11800],
    date_from: new Date().toISOString().substr(0, 10),
    date_to: new Date().toISOString().substr(0, 10),
    menu_from: false,
    modal_from: false,
    menu_to: false,
    modal_to: false,
    menu2: false,
    detail_dialog: false,
    add_dialog: false,
    edit_dialog: false,
    headers: [
      {
        text: " اسم الصنف",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " العدد",
        align: "right",
        value: "name",
        sortable: false
      },
      {
        text: "مخزن من",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "مخزن الي",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "موظف مخزن من",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "موظف مخزن من",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "التاريخ",
        value: "address",
        sortable: false,
        align: "right"
      }
    ],
    active: "",
    select_item: { id: "" },
    select_employer: { id: "" },
    search: "",
    comment: "",
    loading: true,

    khazina_fatworas: [],
    items: [],
    fatworas: [],
    employers: [],
    all_client_fatworas: [],
    all_client_sadads: [],
    theKhazna: {},
    item_detail: {},
    all_of_total: 0,
    omola_total: 0,
    count_of_count: 0,
    madionia_sabqa_of_madionia: "",
    madionia_sabqa: "",
    select_branch: {},
    branches: []
  }),

  computed: {
    mycode() {
      if (this.khazina_fatworas.length > 0) {
        return (this.code =
          parseInt(
            this.khazina_fatworas[this.khazina_fatworas.length - 1].code
          ) + 1);
      } else {
        return (this.code = 1000);
      }
    },
    omola_percentage() {
      return function(total, omola) {
        return (parseFloat(total) * parseFloat(omola)) / 100;
      };
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    this.initialize();
    branches().then(res => {
      this.branches = res.data;
      this.branches.push({ id: 0, name: "كل الفروع" });
    });
  },

  methods: {
    initialize() {
      employers().then(response => {
        this.employers = response.data;
        this.loading = false;
      });

      khazna_fatworas().then(response => {
        this.khazina_fatworas = response.data;
      });

      items().then(response => {
        this.items = response.data;
      });
    },
    search_client_by_code() {
      search_client_by_code(this.searchClientCode).then(response => {
        this.select_item = response.data;
        this.get_all_info();
      });
    },
    get_all_info() {
      this.searchClientCode = this.select_item.code;
      this.fatworas = [];
      this.madionia_sabqa = "";
      this.loading = true;
      fatworas_client_no_sadad(this.select_item.id).then(response => {
        this.fatworas = response.data;
        this.loading = false;
      });
      madionia_client(this.select_item.id).then(response => {
        this.madionia_sabqa =
          (response.data.madionia != 0
            ? parseFloat(response.data.madionia)
            : 0) +
          (response.data.client.rasid_efttahi != ""
            ? parseFloat(response.data.client.rasid_efttahi)
            : 0);
        this.madionia_sabqa_of_madionia =
          response.data.madionia != 0 ? parseFloat(response.data.madionia) : 0;
      });
    },

    get_khazina() {
      khazina(this.select_employer.id).then(response => {
        this.theKhazna = response.data;
      });
    },
    detailItem(order) {
      this.item_detail = order;
    },
    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
      //   setTimeout(() => {
      //     this.editedItem = Object.assign({}, this.defaultItem)
      //     this.editedIndex = -1
      //   }, 300)
    },

    StoreItemTransferReport() {
      var frmData = new FormData();
      frmData.append("branch_id", this.select_branch.id);
      frmData.append("date_from", this.date_from);
      frmData.append("date_to", this.date_to);
      StoreItemTransferReport(frmData).then(response => {
        response.data.length > 0
          ? (this.fatworas = response.data)
          : (this.fatworas = []);
      });
    }
  }
};
</script>

<style scope>
.v-datatable__actions__range-controls {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
</style>
